import Table from './src/table.vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpTable = withInstall(Table)
export default EpTable
export * from './src/table'
export type TableInstance = InstanceType<typeof Table>

